// Copyright (c) 2016 Deere & Company

import t from 'tcomb';

const Tab = t.struct({
    count: t.Number,
    label: t.String,
    route: t.String
}, 'Tab');

export const getDefaultState = () => new Tab({
    count: 0,
    label: '',
    route: ''
});

export default Tab;



// WEBPACK FOOTER //
// ./src/shared/state/tab.js